<template>
	<modal-adicionar-entidades
		:textos-do-template-da-listagem-vazia="textosDaListagemVazia"
		:total-paginas="totalPaginas"
		:total-itens="totalItens"
		:paginacao="paginacao"
		:itens="datasource"
		:exibir="exibir"
		:colunas="getColunasListagemFiscais()"
		:tamanho-maximo-colunas="getTamanhoMaximoColunas()"
		@fechar-modal="$emit('fechar-modal')"
		@paginar="setPaginacao"
		@resetar-page="resetarPaginaItemListagem()"
		@set-filtro="setValorFiltro"
		@adicionar-itens-selecionados="adicionarFiscais"
		titulo-modal="Selecionar Fiscais"
		:modal-options="modalOptions"
		:filtro="filtro"
	></modal-adicionar-entidades>
</template>
<script>
import ModalAdicionarEntidades from '@/views/components/ModalAdicionarEntidades.vue'
import { TabelaColunaUtils } from '@/core/utils'
import paginacaoListagem from '@/core/store/default/paginacaoListagem'
import { actionTypes } from '@/core/constants'
import formatDataFilter from '@/views/filters/format-data-filter'

export default {
	name: 'modal-adicionar-fiscais',
	components: { ModalAdicionarEntidades },
	props: {
		exibir: {
			type: Boolean,
		},
	},
	data() {
		return {
			idAta: this.$route.params.id,
			paginacao: paginacaoListagem('id', 25, 'ASC'),
			datasource: [],
			totalPaginas: 0,
			totalItens: 0,
			textosDaListagemVazia: {
				titulo: 'A ata não possui fiscais cadastrados',
			},
			modalOptions: {
				largura: '45%',
				altura: '80%',
			},
			filtro: {
				nomeFiscalOuNomeOrgaoOuSiglaOrgao: {
					default: null,
					label: 'Pesquisa',
					value: null,
				},
			},
		}
	},
	async mounted() {
		await this.buscarFiscais()
	},
	methods: {
		getColunasListagemFiscais() {
			return [
				new TabelaColunaUtils('Nome', 'nomeFiscal', '40%'),
				new TabelaColunaUtils('Órgão', 'siglaOrgao', '20%'),
				new TabelaColunaUtils('Vigência', 'vigencia', '35%'),
			]
		},
		getTamanhoMaximoColunas() {
			return {
				nomeFiscal: 40,
				siglaOrgao: 20,
				vigencia: 45,
			}
		},
		async adicionarFiscais(fiscais) {
			await this.$store
				.dispatch(actionTypes.ATA.FISCAIS.ADICIONAR_FISCAIS, this.montarPayloadAdicionarFiscais(fiscais))
				.then(() => this.mostrarNotificacaoSucesso('Operação realizada com sucesso.'))

			this.$emit('fechar-modal')
		},
		setValorFiltro(filtro) {
			this.filtro = filtro
		},
		async buscarFiscais() {
			const { itens, totalElements, totalPages } = await this.$store.dispatch(
				actionTypes.ATA.FISCAIS.BUSCAR_FISCAIS_LISTAGEM_MODAL,
				this.montarPayloadBuscarFiscais(),
			)

			this.datasource = this.formatarItens(itens)
			this.totalItens = totalElements
			this.totalPaginas = totalPages
		},
		formatarItens(itens) {
			return itens.map((item) => {
				return {
					vigencia: `${formatDataFilter(item.inicioVigencia)} a ${formatDataFilter(item.fimVigencia)}`,
					...item,
				}
			})
		},
		setPaginacao(paginacao) {
			this.paginacao = paginacao
			this.buscarFiscais()
		},
		resetarPaginaItemListagem() {
			this.paginacao.page = 1
			this.buscarFiscais()
		},
		montarPayloadBuscarFiscais() {
			return {
				filtro: { ...this.filtro, idAta: { value: this.idAta } },
				paginacao: this.paginacao,
			}
		},
		montarPayloadAdicionarFiscais(fiscais) {
			return {
				idAta: this.idAta,
				idsFiscais: fiscais.map((fiscal) => fiscal.id),
			}
		},
	},
}
</script>

<style scoped lang="stylus">
.bg-white {
	background-color white
}
</style>
